<template>
    <div class='item-warp'>
        <Banner :bannerContent="dataInfo.bannerContent"></Banner>
        <div class="content-warp">
            <ContentItem :dataList="dataInfo.listData"></ContentItem>
            <Help :dataList="dataInfo.helpData" :isPartner="isPartner"  :isClass="isClass"></Help>
        </div>
    </div>
</template>

<script>
    import Banner from './banner'
    import ContentItem from './content-item'
    import Help from './help'
    export default {
        name: "item-warp",
        props: {
            dataInfo: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            isPartner: {
                type: Boolean,
                default: false
            },
            // 医学事务帮助我们，左侧颜色标黑
            isClass: {
                type: Boolean,
                default: false
            }
        },
        components: {Banner,ContentItem,Help}
    }
</script>

<style lang='less' scoped>
    .item-warp {
        width: 100%;

        .content-warp {
            width: 100%;
            margin: 0 auto;
        }
    }
</style>